import { Link, InternalIcon } from "@carrotfertility/carotene-core"
import React from "react"

export function ContentfulArrowLink(props) {
  return <Link {...props} textAlign="start" endIcon={<InternalIcon color="primary" fontSize="small" />} />
}
